import React from 'react';
import axios from "axios";
import {Group} from "fearless-common";
import {backendEndpoints} from "../../libs/backendEndpoints";
import {routes} from "../../utils";
import Button, {ButtonProps} from "react-bootstrap/Button";
import {useConfirm} from "../contexts/ConfirmationModalContext";
import {isInAdminEnvironment} from "../../utils/env";

interface GroupDeleteButtonProps {
  group: Group;
  size?: 'sm' | 'lg';
  variant?: ButtonProps['variant'];
}

export default function GroupDeleteButton({ group, size = 'sm', variant = 'outline-danger' }: GroupDeleteButtonProps) {
    const { open } = useConfirm();

    const verb = isInAdminEnvironment() ? 'Archive' : 'Delete';

    return (
        <Button
            variant={variant}
            size={size}
            onClick={() => {
                open(
                    `Are you sure you want to ${verb.toLowerCase()} ${group?.name}?`,
                    () => axios.delete(backendEndpoints.deleteGroup(group.id))
                        .then(() => {
                            if (isInAdminEnvironment()) {
                                window.location.reload();
                            } else {
                                window.location.href = routes.groups;
                            }
                        }),
                    true,
                )
            }}
        >
            {verb} {group?.name}
        </Button>
    );
}
